import React, { useContext, useEffect, useRef, useState } from "react";
import { getInterFirmLedgerStatementData, getLedgerStatementData } from "_services/accountsServices/ledgerStatementServices";
import {
    ButtonHeading,
    CommonDateRange,
    CommonInput,
    CustomPagination,
    NavTabs,
} from "components";
import { UserContext } from "context";
import { utils } from "helper";
import { Link, useNavigate, useParams } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import LoadingBar from "react-top-loading-bar";
import moment from "moment";
import { ConfirmModalFor, PaymentVoucher } from "modals";
import { deleteTransactionApi } from "_services";
import toast from "react-hot-toast";
import { Images } from "constants";
import useDocumentTitle from "hooks/useDocumentTitle";
import { API, AppConfig } from "lib";
import '../../Accounts/Ledger/ledger.css'
import { getSupplierDetailsData } from "_services/accountsServices/supplierServices";
import { useLocation } from "react-router-dom";

const nameObject = {
    1: 'Supplier',
    2: 'Party',
    3: 'Driver',
    4: 'Vendor',
    5: 'Fuel Station',
    8: 'Staff',
}

const InterFirmLedger = (props) => {
    let { setLedgerDetails, supplierDataFunc, setDetailsData } = props;
    let isToken = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    const { pathname } = useLocation();
    const vendorType = pathname.split("/")[2]; // "supplier"
    useDocumentTitle("Ledger | T360");
    let runing_balance = 0;
    let { id } = useParams();
    const navigate = useNavigate();
    const loadingBarRef = useRef(null);
    let { type } = props;

    const [ledgerStatementData, setLedgerStatementData] = useState([]);
    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
        // startDate: moment(firstDay).subtract(31, "days"),
        // endDate: moment(lastDay),
    });

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        // status: 1,
        // start_date: new Date(),
        // end_date: new Date()
    });
    const [confirmModalShow, setConfirmModalShow] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);

    const getDataLedgerStatement = async (idd) => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                ...filter,
                start_date: moment(selectedRange?.startDate).format("YYYY-MM-DD"),
                end_date: moment(selectedRange?.endDate).format("YYYY-MM-DD"),
                company_id: StorageService.getCompanyId(),
                vendor_type: type,
                vendor_id: idd,
            };
            const res = await getInterFirmLedgerStatementData(object);
            if (res?.responseCode == 200) {
                setLedgerDetails(res?.data?.account_detail)
                setLedgerStatementData(res?.data?.list);
                setTotalItems(res?.data?.total_record);
            }
        } catch (error) {
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    };

    const getDataSupplierDetails = async (id_1) => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                supplier_id: id_1,
            }
            const res = await getSupplierDetailsData(object);
            if (res?.responseCode == 200) {
         
                supplierDataFunc(res?.data?.supplier)
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    useEffect(() => {
        getDataLedgerStatement(id);
    }, [id, filter, selectedRange, props.refresh]);

    useEffect(() => {
        if (id && vendorType === "supplier") {
            setLoading(true);
            getDataSupplierDetails(id);
        }
    }, [id])


    const handleApply = (newRange) => {
        setSelectedRange(newRange);
        setFilter((s) => ({ ...s, offset: 1 }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const handleDelete = async () => {
        const payload = {
            company_id: StorageService?.getCompanyId(),
            transaction_id: confirmModalShow?.transaction_id || paymentVoucherOpen?.transaction_id,
        };
        try {
            setDeleteLoading(true);
            const res = await deleteTransactionApi(payload);
            if (res?.responseCode == 200) {
                toast.success(res?.responseMessage);
                setConfirmModalShow(false);
                setDeleteLoading(false);
                getDataLedgerStatement(id);
                setPaymentVoucherOpen(false);
            } else {
                setDeleteLoading(false);
                toast.error(res?.responseMessage);
            }
        } catch (error) {
            setDeleteLoading(false);
            toast.error(error?.message);
        }
    };

    let confirmModalProps = {
        show: confirmModalShow,
        closeModal: (e) => {
            setConfirmModalShow(false);
        },
        title: "Confirm",
        submitTitle: "Delete",
        onSubmit: handleDelete,
        confirmModal: "confirmModal",
        icon: Images.DELETEICON.default,
        isLoadding: deleteLoading,
        disabled: deleteLoading,
    };



    const getCategoriesNames = (item) => {

        if (item?.category_type == 1) {
            return <>{item?.categories[0]?.category?.name}</>;
        }

        if (item?.category_type == 2) {
            return <>{item?.category_name}</>;
        }
    };

    const getDownloadLedgerReport = async () => {
        setLoading(true)
        try {
            const payload = {
                start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
                company_id: StorageService.getCompanyId(),
                vendor_type: type,
                vendor_id: id,
                is_web: true,
            }
            const response = await fetch(`${AppConfig.api_baseurl}${API.LEDGER_REPORT}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // 'text/csv',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${nameObject[type]}-ledger-statement.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const paymentVoucherProps = {
        paymentVoucherOpen: paymentVoucherOpen,
        closeModal: () => setPaymentVoucherOpen(false),
        voucherId: paymentVoucherOpen?._id,
        oprnDeleteModal: setConfirmModalShow
    };

    return (
        <div>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />

            <div className="_rangeDate_bx_ledger">
                <div className="_fleX_inds_ledger">
                    <div className="_divForth">
                        <CommonDateRange
                            initialStartDate={selectedRange.startDate}
                            initialEndDate={selectedRange.endDate}
                            onApply={handleApply}
                        />
                    </div>
                    {/* <div>
                        <button className='_addComm_btn' onClick={(e) => getDownloadLedgerReport(e)} disabled={loading}> {loading ? "Loading..." : 'Download'} </button>
                    </div> */}
                </div>
            </div>

            <div className='__otrLdg_page' >
                <div className="page-wrapper">
                    <section className="__cardLdg __account_tableInfo">
                        <div className="table-header">
                            <h4>Transaction Details</h4>
                        </div>
                        <div className="table-container">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Voucher No.</th>
                                        <th>Transaction Type</th>
                                        <th>Category</th>
                                        <th>Description</th>
                                        <th> Vehicle No. </th>
                                        <th className="right">Debit Amount</th>
                                        <th className="right">Credit Amount</th>
                                        <th className="right">Running Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ledgerStatementData?.length > 0 ? (
                                        ledgerStatementData?.map((el, ind) => {
                                            runing_balance += el?.interfirm_detail?.debit_amount - el?.interfirm_detail?.credit_amount;

                                            return (
                                                <tr>
                                                    <td className="__mediumFont">{utils.getDateByApiResponse(el?.date)}</td>
                                                    <td onClick={() =>
                                                        el?.voucher_no && setPaymentVoucherOpen(
                                                            el
                                                        )
                                                    }> <code className="__codeBg" style={{ cursor: "pointer" }}>{el?.voucher_no ? el?.voucher_no : "-"}{" "}</code></td>
                                                    <td>
                                                        <span
                                                            className={
                                                                (el?.sub_type_name === "Total Freight" || el?.type_name === "Total Freight")
                                                                    ? "badge blueBadge"
                                                                    : (el?.sub_type_name === "Charge Party" || el?.type_name === "Charge Party")
                                                                        ? "badge orangeBadge"
                                                                        : (el?.sub_type_name === "Invoice Payment" || el?.type_name === "Invoice Payment")
                                                                            ? "badge greenBadge"
                                                                            : "badge light"
                                                            }
                                                        >
                                                            {el?.sub_type_name || el?.type_name}
                                                        </span>
                                                    </td>
                                                    <td className="__text_muted">{getCategoriesNames(el)}</td>
                                                    <td>  <div className="dFsx2">
                                                        <div className="fBold">
                                                            <Link
                                                                className=""
                                                                onClick={(e) =>
                                                                    navigate(
                                                                        `/trip/addtrip/dispatched/${el?.trip?._id}`
                                                                    )
                                                                }
                                                            >
                                                                {el?.trip?.trip_number
                                                                    ? `${el?.trip?.trip_number}`
                                                                    : ""}{" "}
                                                            </Link>
                                                            {el?.trip?.route_name
                                                                ? `- ${el?.trip?.route_name}`
                                                                : ""}{" "}
                                                            {el?.trip?.route_name && el?.description
                                                                ? " | "
                                                                : ""}
                                                            {el?.description
                                                                ? `${el?.description}`
                                                                :
                                                                ""}
                                                        </div>

                                                    </div></td>
                                                    <td className="__mediumFont"> {el?.tags?.vehicle?.vehicle_no ? el?.tags?.vehicle?.vehicle_no : '-'} </td>
                                                    <td className="right __redFont __mediumFont"> {el?.interfirm_detail?.debit_amount ? `₹ ${(el?.interfirm_detail?.debit_amount).toFixed(2)} ` : "-"}</td>
                                                    <td className="right __mediumFont" style={{ color: "green" }}>  {el?.interfirm_detail?.credit_amount ? `₹ ${(el?.interfirm_detail?.credit_amount).toFixed(2)} ` : "-"}</td>
                                                    <td className="right __mediumFont">{runing_balance ? ` ₹ ${(runing_balance).toFixed(2)}` : `₹ 0`}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td></td>
                                            <td className="p-2"> No data </td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                        <div className="table-footer">
                            <span></span>
                            {/* Showing 1–10 of 10 transactions */}

                            {ledgerStatementData?.length > 0 ? (
                                <div className="paginationFt_avt rmRBs">
                                    <CustomPagination
                                        totalItems={totalItems}
                                        itemsPerPage={itemsPerPage}
                                        currentPage={filter?.offset}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            ) : <></>}


                        </div>
                    </section>


                    <section className="__cardLdg __footer_notes">
                        <div className="grid two-cols">
                            <div>
                                <h4>Important Notes</h4>
                                <ul className="notes">
                                    <li className="__text_muted">• All amounts are in Indian Rupees (INR)</li>
                                    <li className="__text_muted">• This statement is generated electronically</li>
                                    <li className="__text_muted" style={{ marginBottom: '0px' }}>• For queries, contact our accounts
                                        department</li>
                                </ul>
                            </div>
                            <div className="text-right">
                                <p className="__text_muted">Statement generated on</p>
                                <p className="bold">{moment(new Date()).format('DD MMM YYYY')}, {moment(new Date()).format('hh:mm A')}</p>
                            </div>
                        </div>
                    </section>
                </div>

            </div >



            {confirmModalShow && (
                <ConfirmModalFor {...confirmModalProps}>
                    <>
                        <p className="_confirmPrx"> Are you sure you want to delete ?</p>
                    </>
                </ConfirmModalFor>
            )}

            {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
        </div>
    );
};

export default InterFirmLedger;

